module.exports = __webpack_public_path__ + "img/tel.ee5b1788.png";